import { render, staticRenderFns } from "./StockLineSyncedQtyFields.vue?vue&type=template&id=0242704a&scoped=true"
import script from "./StockLineSyncedQtyFields.vue?vue&type=script&lang=js"
export * from "./StockLineSyncedQtyFields.vue?vue&type=script&lang=js"
import style0 from "./StockLineSyncedQtyFields.vue?vue&type=style&index=0&id=0242704a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0242704a",
  null
  
)

export default component.exports